<app-table
    [items]="data()"
    [columns]="columns()"
    translatePrefix="dashboard.riskyClients."
    [hideCheckboxes]="true"
    [smallButtons]="true"
>
    <ng-template pTemplate="status" let-data="data">
        <div
            [ngClass]="{ 'danger': data === FolderRiskStatusEnum.POSITIVE, 'warning': data === FolderRiskStatusEnum.RISKY }">{{ 'enum.folderRiskStatus.' + data | translate }}
        </div>
    </ng-template>
</app-table>
